import axios from 'axios';
export const getEventStatus=() =>{
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`event-status`
  );
}
export const AddEventStatus=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`event-status/create`,
    obj,
    { headers }
  );
}

export const EditEventStatus=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`event-status/update`,
    obj,
    { headers }
  );
}

export const DeleteEventStatus=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`event-status/delete`,
    obj,
    { headers }
  );
}